import { useContext } from 'react';

import { ScrollCollapseContext } from '~/components/ScrollCollapse/contexts/ScrollCollapseContext';

export const useScrollCollapseContext = () => {
  const context = useContext(ScrollCollapseContext);

  if (!context) {
    throw new Error(
      'useScrollCollapseContext must be used within a ScrollCollapseProvider',
    );
  }

  return context;
};
